import { urls } from '../../constants/urls';
const AEM_PATH_PREFIX = '/content/waitrosegroceriescms/en/';
const AEM_CONTENT = 'wtr-content';
export default (path) => {
    let url = path;
    if (url.includes(AEM_PATH_PREFIX)) {
        const frontEndPath = url.replace(AEM_PATH_PREFIX, '').replace(AEM_CONTENT, 'content');
        url = `${urls.root}/${frontEndPath}`;
    }
    return url;
};
//# sourceMappingURL=cms-path-to-url.js.map